module.exports = __webpack_public_path__ + "media/assets/Send-3af41d335a0f9c274cd85c747bc8884c.svg";